<template>
  <stepper-content-card
    @skipStep="$emit('skipStep')"
    @changeStep="handleStepChange"
    :dataLoading="dataLoading"
    :step="3"
    imgUrl="https://images.unsplash.com/photo-1554825203-68321ddde262?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1085&q=80"
  >
    <div slot="heading">Joining Session</div>
    <div slot="subheading">When can you join with us</div>
    <div slot="body">
      <v-row no-gutters>
        <v-col cols="12">
          <v-checkbox v-model="desserts" value="cupcakes" hide-details label="Summer"></v-checkbox>
          <v-checkbox v-model="desserts" value="brownies" hide-details label="Winter"></v-checkbox>
          <v-checkbox v-model="desserts" value="cheesecakes" hide-details label="Anytume"></v-checkbox>
          <!-- <v-checkbox v-model="desserts" value="mug_cakes" hide-details label="Mug Cakes"></v-checkbox> -->
        </v-col>
      </v-row>
    </div>
  </stepper-content-card>
</template>

<script>
import StepperContentCard from "./StepperContentCard";
import { mapGetters } from "vuex";

export default {
  props: ["currentPerson", "dataLoading"],
  data() {
    return {
      desserts: [] 
    };
  },
  mounted() {
    this.desserts = [...this.currentPerson.desserts]
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    handleStepChange() {
      if (!this.desserts.length) {
        this.$setSnackbar("Please select at least one option");
        return;
      }

      this.$emit("changeStep", {
        desserts: this.desserts,
      });
    },
  },
  components: {
    StepperContentCard,
  },
};
</script>